import React, { Component } from "react";
import { observer } from "mobx-react";
import { Segment, Header, Icon, Button } from "semantic-ui-react";
import PropTypes from "prop-types";
import Immersive3dTourAppPageStore from "~/stores/Immersive3dTourAppPageStore";

@observer
class ProcessingSection extends Component {
  render() {
    const { immersive3dTourAppPageStore } = this.props;
    const { immersive3dTourStore } = immersive3dTourAppPageStore;
    const { immersive3dTour } = immersive3dTourStore;

    let sitTightMessage = "Sit tight, we are processing your Immersive 3D Tour!";
    let secondaryMessage = "We will send you an email once the processing is completed.";
    let processingRequestDts = immersive3dTour.confirmedDts ? immersive3dTour.confirmedDts.format("llll") : "N/A";

    if (immersive3dTour.hasActiveReplacePanoramaRequest) {
      sitTightMessage = "Sit tight, we are replacing panoramas at your Immersive 3D Tour!";
      secondaryMessage = "The page will update automatically when the processing is done";
      processingRequestDts = immersive3dTour.replacePanoramaRequestDts
        ? immersive3dTour.replacePanoramaRequestDts.format("llll")
        : "N/A";
    }

    return (
      <>
        {immersive3dTourAppPageStore.hasCompletedInitialProcessing && !immersive3dTour.hasActiveReplacePanoramaRequest && (
          <Segment secondary textAlign="center">
            <Header>The initial processing of your Immersive 3D Tour has been successful!</Header>
            <p>
              While your Immersive 3D Tour is being processed by our team, you can take this opportunity to edit
              (post-process) your panoramas. You can download, make the changes and re-upload the panoramas at the
              Replace panoramas page.
            </p>
            <Button icon primary onClick={() => immersive3dTourAppPageStore.goToReplacePanoramaPage()}>
              <Icon name="redo" /> Replace panoramas
            </Button>
          </Segment>
        )}
        <Segment placeholder>
          <Header icon>
            <Icon name="cogs" />
            {sitTightMessage}
          </Header>
          <Segment.Inline>
            <p>It was sent to processing at {processingRequestDts}.</p>
            <p>{secondaryMessage}</p>
          </Segment.Inline>
        </Segment>
      </>
    );
  }
}

ProcessingSection.propTypes = {
  immersive3dTourAppPageStore: PropTypes.instanceOf(Immersive3dTourAppPageStore),
};

export default ProcessingSection;
